import React from "react";

const Modal = (props) => (
    <div style={{zIndex: 999, backgroundColor: "rgba(255,255,255,0.8)", position: "fixed", top: 0, left: 0, right: 0, bottom: 0}}>
        <div style={{backgroundColor: "white", width: 400, padding: 10, borderRadius: 4, margin: "60px auto", boxShadow: "0px 0px 23px 3px rgba(0,0,0,0.3)"}}>
            <div style={{float: "right"}} onClick={props.onClose}>
                <span style={{cursor: "pointer", color: "#0078e7", borderBottom: "1px solid #0078e7"}}>close</span>
            </div>
            {props.children}
        </div>
    </div>
);

export default Modal;


/** WEBPACK FOOTER **
 ** ./src/main/javascript/common/components/Modal.js
 **/